/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Heading,
  SelectField,
  SwitchField,
  Text,
  TextField,
} from "@aws-amplify/ui-react";
import MyIcon from "./MyIcon";
export default function FamilyHistoryDetails(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="0"
      direction="column"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="80px 56px 80px 56px"
      backgroundColor="rgba(255,255,255,1)"
      {...getOverrideProps(overrides, "FamilyHistoryDetails")}
      {...rest}
    >
      <Flex
        gap="24px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="center"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="32px 32px 32px 32px"
        backgroundColor="rgba(250,250,250,1)"
        {...getOverrideProps(overrides, "fhArea")}
      >
        <Heading
          width="unset"
          height="60px"
          shrink="0"
          level="1"
          children="Family History Details"
          {...getOverrideProps(overrides, "fhHeading")}
        ></Heading>
        <TextField
          width="300px"
          height="58px"
          label="First Name"
          shrink="0"
          placeholder="Placeholder"
          size="small"
          isDisabled={false}
          labelHidden={false}
          variation="default"
          {...getOverrideProps(overrides, "fhName416022900")}
        ></TextField>
        <TextField
          width="300px"
          height="58px"
          label="Last Name"
          shrink="0"
          placeholder="Placeholder"
          size="small"
          isDisabled={false}
          labelHidden={false}
          variation="default"
          {...getOverrideProps(overrides, "fhName416022986")}
        ></TextField>
        <TextField
          width="300px"
          height="58px"
          label="Age"
          shrink="0"
          placeholder="Placeholder"
          size="small"
          isDisabled={false}
          labelHidden={false}
          variation="default"
          {...getOverrideProps(overrides, "fhAge")}
        ></TextField>
        <SelectField
          width="300px"
          height="unset"
          label="Relationship"
          placeholder="Mother"
          shrink="0"
          size="default"
          isDisabled={false}
          labelHidden={false}
          variation="default"
          {...getOverrideProps(overrides, "ifhRelationshipSelectField")}
        ></SelectField>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          {...getOverrideProps(overrides, "Divider416022907")}
        ></Divider>
        <Text
          fontFamily="Inter"
          fontSize="14px"
          fontWeight="400"
          color="rgba(0,0,0,1)"
          lineHeight="21px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Illness List:"
          {...getOverrideProps(overrides, "fhIlinessTagsLabel")}
        ></Text>
        <Flex
          gap="8px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          overflow="hidden"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          border="1px SOLID rgba(4,125,149,1)"
          borderRadius="4px"
          padding="10px 7px 10px 7px"
          {...getOverrideProps(overrides, "fhTagsView")}
        >
          <Flex
            gap="0"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            position="relative"
            borderRadius="32px"
            padding="0px 6px 0px 6px"
            backgroundColor="rgba(239,240,240,1)"
            {...getOverrideProps(overrides, "TagContainer1416022910")}
          >
            <Badge
              width="unset"
              height="unset"
              gap="0"
              shrink="0"
              size="small"
              variation="default"
              children="Hypertension"
              {...getOverrideProps(overrides, "Badge1416022911")}
            ></Badge>
            <MyIcon
              width="14px"
              height="14px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              overflow="hidden"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              type="close"
              {...getOverrideProps(overrides, "icNoteIcon1416022912")}
            ></MyIcon>
          </Flex>
          <Flex
            gap="0"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            position="relative"
            borderRadius="32px"
            padding="0px 6px 0px 6px"
            backgroundColor="rgba(239,240,240,1)"
            {...getOverrideProps(overrides, "TagContainer1416022976")}
          >
            <Badge
              width="unset"
              height="unset"
              gap="0"
              shrink="0"
              size="small"
              variation="default"
              children="Diabetes"
              {...getOverrideProps(overrides, "Badge1416022977")}
            ></Badge>
            <MyIcon
              width="14px"
              height="14px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              overflow="hidden"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              type="close"
              {...getOverrideProps(overrides, "icNoteIcon1416022978")}
            ></MyIcon>
          </Flex>
          <Flex
            gap="0"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            position="relative"
            borderRadius="32px"
            padding="0px 6px 0px 6px"
            backgroundColor="rgba(239,240,240,1)"
            {...getOverrideProps(overrides, "TagContainer1416022981")}
          >
            <Badge
              width="unset"
              height="unset"
              gap="0"
              shrink="0"
              size="small"
              variation="default"
              children="Gastritis"
              {...getOverrideProps(overrides, "Badge1416022982")}
            ></Badge>
            <MyIcon
              width="14px"
              height="14px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              overflow="hidden"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              type="close"
              {...getOverrideProps(overrides, "icNoteIcon1416022983")}
            ></MyIcon>
          </Flex>
        </Flex>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          {...getOverrideProps(overrides, "Divider416022913")}
        ></Divider>
        <SwitchField
          width="unset"
          height="unset"
          label="Lives?"
          shrink="0"
          size="small"
          defaultChecked={true}
          isDisabled={false}
          labelPosition="end"
          {...getOverrideProps(overrides, "fhLivesSwitch")}
        ></SwitchField>
        <Flex
          gap="18px"
          direction="column"
          width="unset"
          height="34px"
          justifyContent="center"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "FooterActions")}
        >
          <Button
            width="unset"
            height="unset"
            justifyContent="flex-end"
            shrink="0"
            size="default"
            isDisabled={false}
            variation="primary"
            children="Save"
            {...getOverrideProps(overrides, "SaveButton")}
          ></Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
